import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  cardContainer: {
    backgroundColor: "#368FFF",
    margin: "15px",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "22px",
    gap: "42px",
    maxHeight: "670px",
  },
  content: {
    display: "flex",
    flexDirection: "column",
  },
  title: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(30),
    lineHeight: "140%",
    color: "white",
    textAlign: "center",
  },
  subtitle: {
    fontFamily: "Lato",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(18),
    lineHeight: "24px",
    color: "white",
    textAlign: "center",
    margin: "20px 50px",
  },
  image: {
    display: "flex",
    alignContent: "center",
    borderRadius: "100%",
    width: "350px",
    height: "350px",
    backgroundColor: "#74acf5",
    alignSelf: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  imageReduced: {
    width: "280px",
    height: "280px",
  },
  dateTimeBlock: {
    padding: "15px",
    borderTop: "1px solid lightblue",
    borderBottom: "1px solid lightblue",
    marginTop: "35px",
    fontFamily: "Lato",
    fontSize: theme.typography.pxToRem(18),
    color: "white",
    display: "flex",
    alignSelf: "center",
    alignItems: "center",
    width: "80%",
    justifyContent: "space-between",
    "& span": {
      alignItems: "center",
      alignContent: "center",
      display: "flex",
      padding: "0 10px 0 10px",
    },
  },
  svgIcons: {
    fill: "white",
    marginRight: "10px",
  },
  button: {
    marginTop: "35px",
    backgroundColor: "transparent",
    fontFamily: "Inter",
    color: "white",
    border: "1px solid white",
    borderRadius: "100px",
    padding: "8px 30px",
    textTransform: "none",
    fontSize: theme.typography.pxToRem(16),
    alignSelf: "center",
    "& .MuiSvgIcon-root": {
      color: "#59d7ed",
      fontSize: theme.typography.pxToRem(20),
      fontWeight: 900,
    },
    "&.MuiButton-root:hover": {
      backgroundColor: "white",
      color: "#0344dc",
    },
  },
}));
